import React from "react";
import Text from "../../../components/Common/Text";
import CheckRender from "../../../components/Common/CheckRender";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomTable from "../../../components/CustomTable/CustomTable";
import useEmpresa from "../../../hooks/useEmpresa";
import Colors from "../../../themes/Colors";
import {
  Row,
  DetallePrecertificacionContainer,
  DetallePrecertificacionContent,
  InfoContainer,
  LeftAligned,
  CodigosContainer,
  CodigoContainer,
  ButtonWrapper,
} from "../styles/PrecertificacionStyles";
import { AlertWarning } from "../../../components/Common/CommonStyles";
import { columnsDetallePrecertificacion, ESTADO_PRECERTIFICACION } from "../utils/PrecertificacionConstants";
import { DATOS_FIJOS_AUTORIZACION } from "../../autorizacion/utils/AutorizacionConstant";
import moment from "moment";

const DetallePrecertificacion = ({
  dataPrecertificacion,
  dataAutorizacion,
  showAutorizacion,
  actionButtonLoading,
  onSubmitAction,
  actionButton,
  warningText,
}) => {
  const empresa = useEmpresa();

  const {
    numeroPrecertificacion,
    nombrePss,
    codigoPss,
    afiliado,
    fecha,
    usuarioIngreso,
    nombreEstado,
    procedimientos,
  } = dataPrecertificacion;

  const styleButtonAutorizar = {
    bgColor: empresa?.COLOR_SECUNDARIO,
    hoverColor: empresa?.COLOR_PRINCIPAL,
  };

  const styleButtonCancelar = {
    bgColor: Colors.white,
    hoverColor: Colors.huMyHealth,
    textColor: Colors.huMyHealth,
    border: `1px solid ${Colors.huMyHealth}`,
  };

  const getActionButtonStyleProps = () => {
    switch (actionButton) {
      case "Autorizar":
        return styleButtonAutorizar;
      case "Cancelar":
        return styleButtonCancelar;
      default:
        return styleButtonAutorizar;
    }
  };

  return (
    <DetallePrecertificacionContainer>
      <AlertWarning>
        <Text size={"15px"} color={Colors.warning} weight={"bold"} margin={"0"}>
          {warningText}
        </Text>
      </AlertWarning>

      <CustomSeparator height={"10px"} />

      <DetallePrecertificacionContent>
        <CodigosContainer>
          <LeftAligned>
            <CodigoContainer>
              <Text size={"50px"} isTittle={true} weight={"bold"} margin={"0"}>
                {numeroPrecertificacion}
              </Text>
              <Text size="20px" weight={"bold"} margin={"0"}>
                {`Código de precertificación`}
              </Text>
            </CodigoContainer>
          </LeftAligned>
          <CheckRender allowed={showAutorizacion}>
            <LeftAligned>
              <CodigoContainer>
                <Text
                  size={"50px"}
                  isTittle={true}
                  weight={"bold"}
                  margin={"0"}
                >
                  {dataAutorizacion?.numeroAutorizacion}
                </Text>
                <Text size="30px" weight={"bold"} margin={"0"}>
                  {`Número Autorización`}
                </Text>
              </CodigoContainer>
            </LeftAligned>
          </CheckRender>
        </CodigosContainer>
        <Row>
          <hr />
          <Text size="20px" weight={"bold"}>
            {`Datos de precertificación`}
          </Text>
          <Text size="16px">{`${nombrePss}, código ${codigoPss}`}</Text>
          <hr />
        </Row>
        <Row>
          <Text size="18px">
            <strong>{`Autorizamos a suministrar a nuestro ${empresa?.TIPO_CLIENTE?.toLowerCase()} ${
              afiliado?.nombres
            } ${afiliado?.apellidos}`}</strong>
          </Text>
          <hr />
        </Row>
        <InfoContainer>
          <LeftAligned>
            <Text size="16px">
              <strong>{`Carnet No.: `}</strong>
              {afiliado?.numeroPlastico}
            </Text>
            <Text size="16px">
              <strong>{`Documento: `}</strong>
              {`Cédula`}
            </Text>
            <Text size="16px">
              <strong>{`Número: `}</strong>
              {afiliado?.cedula}
            </Text>
            <Text size="16px">
              <strong>{`Plan: `}</strong>
              {afiliado?.plan}
            </Text>
          </LeftAligned>
          <LeftAligned>
            <Text size="16px">
              <strong>{`Autorización válida: `}</strong>
              {moment(fecha)
                ?.add(
                  DATOS_FIJOS_AUTORIZACION.FECHA_VALIDA_HASTA.CANTIDAD_TIEMPO,
                  DATOS_FIJOS_AUTORIZACION.FECHA_VALIDA_HASTA.INTERVALO_TIEMPO
                )
                ?.format("YYYY-MM-DD")}
            </Text>
            <Text size="16px">
              <strong>{`Oficial de Servicios: `}</strong>
              {usuarioIngreso}
            </Text>
            <Text size="16px">
              <strong>{`Estado: `}</strong>
              {nombreEstado}
            </Text>
          </LeftAligned>
        </InfoContainer>
        <hr />
        <CustomTable
          columns={columnsDetallePrecertificacion(empresa)}
          dataSource={procedimientos || []}
          pageSize={100}
          showPagination={procedimientos?.length > 100}
          width={"100%"}
        />
        <Row>
          <hr />
          <Text size="16px">
            {`Autorizo la revisión de mi expediente médico al personal de Auditoría Médica designado por
             ${empresa?.NOMBRE} con el fin de evaluar integralmente la atención prestada.`}
          </Text>
        </Row>
      </DetallePrecertificacionContent>

      <CheckRender allowed={nombreEstado === ESTADO_PRECERTIFICACION.VIGENTE}>
        <ButtonWrapper>
          <CustomButton
            label={actionButton}
            onClick={onSubmitAction}
            isLoading={actionButtonLoading}
            weight={"bold"}
            {...getActionButtonStyleProps()}
          />
        </ButtonWrapper>
      </CheckRender>
    </DetallePrecertificacionContainer>
  );
};

export default DetallePrecertificacion;
